import React from 'react';
import { ButtonMinorAction } from '../../../../Btn/ButtonWrapper';
import { TooltipPlacement } from '../../../../../atoms/Tooltip';
import { Icons } from '../../../../../atoms/SVG';

type CategoryListItemProps = {
  title: string;
  hexColor?: string;
  remove?: () => void;
  removeText?: string;
};
export function CategoryListItem({ title, hexColor, remove, removeText }: CategoryListItemProps) {
  return (
    <div className="category-list-item" style={{ borderLeftColor: hexColor }}>
      <span className="category-list-item__title">{title}</span>
      {remove && removeText && (
        <ButtonMinorAction
          icon={Icons.DELETE_X_SMALL}
          text={removeText}
          onClick={remove}
          tooltipPlacement={TooltipPlacement.LEFT}
        />
      )}
    </div>
  );
}
